import ModalContainer from '../modalContainer';
import { useEffect } from 'react';
import './style.scss';

function EvidencePreviewModal({
  open,
  sourceUrl,
  fileType = 'image',
  fileName = '',
  onClose,
  onPrevious,
  onNext,
  currentIndex,
  totalItems,
  closeOnBackdrop = false
}) {
  useEffect(() => {
    if (!open) return undefined;

    function handleKeyDown(event) {
      if (event.key === 'Escape') onClose?.();
      if (event.key === 'ArrowLeft') onPrevious?.();
      if (event.key === 'ArrowRight') onNext?.();
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose, onPrevious, onNext]);

  if (!open || !sourceUrl) return null;

  return (
    <ModalContainer>
      <div
        className='evidence-preview-modal__backdrop'
        onMouseDown={closeOnBackdrop ? onClose : undefined}>
      <section
        className='evidence-preview-modal'
        role='dialog'
        aria-modal='true'
        aria-label='Vista previa de evidencias'
        onMouseDown={event => event.stopPropagation()}>
        <div className='evidence-preview-modal__toolbar'>
          {Number.isInteger(currentIndex) && Number(totalItems) > 0 ? (
            <span>
              Evidencia {currentIndex + 1} de {totalItems}
            </span>
          ) : <span />}
        <button
          type='button'
          className='evidence-preview-modal__close'
          aria-label='Cerrar vista previa'
          onClick={onClose}
        >
          <span className='material-symbols-rounded'>close</span>
        </button>
        </div>
        <div className='evidence-preview-modal__content'>
          {onPrevious && (
            <button
              type='button'
              className='evidence-preview-modal__nav evidence-preview-modal__nav--previous'
              aria-label='Evidencia anterior'
              onClick={onPrevious}>
              <span className='material-symbols-rounded'>chevron_left</span>
            </button>
          )}
          {fileType === 'pdf' ? (
            <iframe
              className='evidence-preview-modal__frame'
              src={sourceUrl}
              title={fileName || 'Vista previa PDF'}
            />
          ) : (
            <img
              className='evidence-preview-modal__image'
              src={sourceUrl}
              alt={fileName || 'Vista previa evidencia'}
            />
          )}
          {onNext && (
            <button
              type='button'
              className='evidence-preview-modal__nav evidence-preview-modal__nav--next'
              aria-label='Evidencia siguiente'
              onClick={onNext}>
              <span className='material-symbols-rounded'>chevron_right</span>
            </button>
          )}
        </div>
        <p
          className='evidence-preview-modal__name'
          title={fileName || 'Evidencia'}
        >
          {fileName || 'Evidencia'}
        </p>
      </section>
      </div>
    </ModalContainer>
  );
}

export default EvidencePreviewModal;
